import React from "react";
import {withRouter} from "react-router-dom";
import { PageHeader, Button, Modal, Table, Tag, Input, Checkbox } from 'antd';
import { PlusOutlined, EditOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { withTranslation} from 'react-i18next'
import { isEmptyObject, isUndefined } from "../../utils/JsObjectHelper";
//import { isEmptyValue } from "../../utils/JsObjectHelper";

const { Column } = Table;
const { Search } = Input;

class LineageList extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            searchNameText: [],
            advSearchPageSize: (isEmptyObject(localStorage.getItem("setupLineagePageSize")) ? 30 : parseInt(localStorage.getItem("setupLineagePageSize")) )
        };

        this.onMount = this.onMount.bind(this);
        this.filterEntryTypes = this.filterEntryTypes.bind(this);
    }

    showTotal = (total) => {
        return `(${total})`;
    };

    handlePageSizeChanged = (current, page) => {
        localStorage.setItem("setupLineagePageSize", page);
        this.setState({ advSearchPageSize: page });
    };

    componentDidMount() {
        this.onMount();
    }

    onMount(entryId) {
        this.props.onMount();
    }

    filterEntryTypes = (searchValue) => {
        this.setState({searchNameText: searchValue.split(' ')});
    }

    createNewEntryType = () => {
        this.props.history.push(`/setup/lineageedit/`);
    }

    editEntryType = (e, record) => {
        this.props.history.push(`/setup/lineageedit/` + record.name);
    }

    render () {
        const {t} = this.props;

        let info = () => {
            Modal.info({
                title: t('setup.lineageSetup.infoTitle'),
                content: (
                    <div>
                        {t('setup.lineageSetup.infoText')}
                    </div>
                ),
                onOk() {
                },
            });
        };

        let paginationSetup = {
            showSizeChanger: true, 
            size:"small", 
            showTotal: this.showTotal, 
            defaultPageSize: this.state.advSearchPageSize, 
            pageSizeOptions: ['10', '20', '30', '50', '100'],
            onShowSizeChange: this.handlePageSizeChanged
        };

        return (
            <div>
                <PageHeader
                    title={t('setup.lineageSetup.listTitle')}
                    subTitle={t('setup.lineageSetup.listTitleHint')}
                    extra={[
                        <Button key="info-circle-button-key" icon={<InfoCircleOutlined />} /* type="primary" */ onClick={info}>
                        </Button>,
                    ]}
                >
                </PageHeader>
                <Table 
                    dataSource={this.props.lineageSettingsList}
                    rowKey= {record => record.name}
                    size="small"
                    scroll={{ x: true }}
                    loading={isUndefined(this.props.lineageSettingsList)}
                    pagination={paginationSetup}
                    title={() => <div className="searchForSetup">
                        <Button type="primary" style={{marginRight: '15px', marginBottom: '10px'}} onClick={this.createNewEntryType}><PlusOutlined /> {t('setup.lineageSetup.btnAddLineageSetup')}</Button>
                        <Search
                            placeholder={t('setup.lineageSetup.searchBoxHint')}
                            onSearch={this.filterEntryTypes}
                            style={{ width: '100%' }}
                            allowClear
                        />
                        </div>}
                >
                    <Column
                        title={t('setup.lineageSetup.tblAction')}
                        key="action"
                        render={(text, record) => (
                            <span>
                                <Button onClick={(e) => {this.editEntryType(e,record)}}><EditOutlined /> {t('setup.lineageSetup.tblBtnEditLineageSetup')}</Button>
                            </span>
                            )}
                    />
                    <Column 
                        title={t('setup.lineageSetup.tblName')}
                        dataIndex={["value","lineageName"]}
                        key="value.lineageName" 
                        render={(text, record) => (
                            <span><b>{record.value.lineageName}</b></span>
                        )}
                        filteredValue= {this.state.searchNameText}
                        onFilter= {(value, record) => record.value.lineageName.toLowerCase().includes(value.toLowerCase())}
                        sorter= {(a, b) => {
                            return (isUndefined(a.value.lineageName) ? "" : a.value.lineageName).localeCompare((isUndefined(b.value.lineageName) ? "" : b.value.lineageName));
                        }}
                    />
                    <Column
                        title={t('setup.lineageSetup.tblEntryTypes')}
                        dataIndex={["value","entryTypesNameList"]}
                        key="value.entryTypesNameList"
                        render={tags => (
                            <span>
                                {tags.map(tag => (
                                    <Tag color="blue" key={tag}>
                                        {tag}
                                    </Tag>
                                ))}
                            </span>
                        )}
                    />
                    <Column
                        title={t('setup.lineageSetup.tblIsDisplayed')}
                        dataIndex={["value","isDisplayed"]}
                        key="value.isDisplayed"
                        width={100}
                        render={isDisp => (
                            <Checkbox disabled checked={isDisp}></Checkbox>
                        )}
                    />
                </Table>
            </div>
        );
    }
}

const LineageListWithRouter = withRouter(LineageList);

export default withTranslation() (LineageListWithRouter);